import api from '../../services/api';

export interface DashboardData {
  texto?: string;
  bajada?: string;
  imagen?: string;
  url_video?: string;
}

async function getRightDashboard() {
  const response = await api<DashboardData>('GET', 'dashboard/home_right');

  return response;
}

async function getLeftDashboard() {
  const response = await api<DashboardData>('GET', 'dashboard/home_left');

  return response;
}

const dashboardAPI = {
  getRightDashboard,
  getLeftDashboard,
};

export default dashboardAPI;
